import { Button } from "@/components/ui/button";
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { Mail, ChevronDown } from "lucide-react";

const TO = "decomplexe.formation@gmail.com";

const providers = (subject) => {
  const su = encodeURIComponent(subject);
  return [
    { key: "gmail", label: "Gmail", url: `https://mail.google.com/mail/?view=cm&fs=1&to=${TO}&su=${su}` },
    { key: "outlook", label: "Outlook", url: `https://outlook.live.com/mail/0/deeplink/compose?to=${TO}&subject=${su}` },
    { key: "yahoo", label: "Yahoo Mail", url: `https://compose.mail.yahoo.com/?to=${TO}&subject=${su}` },
  ];
};

// A button that lets the visitor pick their email provider (Gmail / Outlook / Yahoo)
// or their default mail app, instead of always opening the OS default (Outlook).
export default function ContactEmailMenu({ subject, label = "Me contacter par e-mail", className = "", variant = "primary", testid = "contact-email-menu" }) {
  const base = "dec-pill h-12 px-6 w-full sm:w-auto";
  const styles = variant === "primary"
    ? "bg-[#D95D39] hover:bg-[#C04E2D] text-white"
    : variant === "ghost-light"
      ? "bg-transparent border border-white/40 text-white hover:bg-white/10"
      : "bg-white border border-[#1F2421]/15 text-[#1F2421] hover:bg-[#F4EFEA]";

  const open = (url) => window.open(url, "_blank", "noopener,noreferrer");
  const openDefault = () => { window.location.href = `mailto:${TO}?subject=${encodeURIComponent(subject)}`; };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button data-testid={testid} className={`${base} ${styles} ${className}`}>
          <Mail className="w-4 h-4 mr-2" /> {label} <ChevronDown className="w-4 h-4 ml-1.5 opacity-70" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="center" className="bg-white w-56">
        <DropdownMenuLabel className="text-xs text-[#5C6561]">Choisissez votre messagerie</DropdownMenuLabel>
        {providers(subject).map((p) => (
          <DropdownMenuItem key={p.key} onClick={() => open(p.url)} data-testid={`${testid}-${p.key}`} className="cursor-pointer">
            {p.label}
          </DropdownMenuItem>
        ))}
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={openDefault} data-testid={`${testid}-default`} className="cursor-pointer text-[#5C6561]">
          Autre / application par défaut
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
